import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cacc0f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { class: "top-tabs tabs-buttons" }
const _hoisted_3 = ["disabled", "title", "onClick"]
const _hoisted_4 = { class: "content-container" }
const _hoisted_5 = { class: "top-content" }
const _hoisted_6 = { class: "flex-row-centered" }
const _hoisted_7 = {
  key: 0,
  class: "center-buttons"
}
const _hoisted_8 = ["onClick", "disabled", "title"]
const _hoisted_9 = {
  key: 1,
  class: "center-buttons"
}
const _hoisted_10 = ["disabled", "title"]
const _hoisted_11 = {
  key: 0,
  class: "content-container"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "table-container"
}
const _hoisted_15 = { class: "export-csv" }
const _hoisted_16 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['inner-table-row'])
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "small" }, null, -1))
const _hoisted_18 = ["colspan"]
const _hoisted_19 = {
  key: 0,
  class: "content-container"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "inner-table-cont" }
const _hoisted_23 = { class: "export-csv" }
const _hoisted_24 = {
  key: 2,
  class: "table-container"
}
const _hoisted_25 = { class: "export-csv" }
const _hoisted_26 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['inner-table-row'])
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "small" }, null, -1))
const _hoisted_28 = ["colspan"]
const _hoisted_29 = {
  key: 0,
  class: "content-container"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "table-container"
}
const _hoisted_33 = { class: "inner-table-cont" }
const _hoisted_34 = { class: "export-csv" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(['inner-table-row'])
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "small" }, null, -1))
const _hoisted_38 = ["colspan"]
const _hoisted_39 = { class: "inner-table-cont" }
const _hoisted_40 = {
  key: 0,
  class: "content-container"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "export-csv" }
const _hoisted_44 = {
  key: 3,
  class: "table-container"
}
const _hoisted_45 = { class: "export-csv" }
const _hoisted_46 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['inner-table-row'])
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "small" }, null, -1))
const _hoisted_48 = ["colspan"]
const _hoisted_49 = {
  key: 0,
  class: "content-container"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "inner-table-cont" }
const _hoisted_53 = { class: "export-csv" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { style: {"color":"green"} }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { style: {"color":"red"} }
const _hoisted_58 = {
  key: 4,
  class: "table-container"
}
const _hoisted_59 = { class: "export-csv" }
const _hoisted_60 = {
  key: 0,
  class: "inner-table-row"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "small" }, null, -1))
const _hoisted_62 = ["colspan"]
const _hoisted_63 = {
  key: 0,
  class: "content-container"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = {
  key: 1,
  class: "table-container"
}
const _hoisted_67 = { class: "inner-table-cont" }
const _hoisted_68 = { class: "export-csv" }
const _hoisted_69 = {
  key: 0,
  class: "inner-table-row"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "small" }, null, -1))
const _hoisted_71 = ["colspan"]
const _hoisted_72 = { class: "inner-table-cont" }
const _hoisted_73 = {
  key: 0,
  class: "content-container"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "export-csv" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { style: {"color":"green"} }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { style: {"color":"red"} }

import { onMounted, ref, watch, computed } from "vue";
import TablePersistentChecking from "@/components/TablePersistentChecking.vue";
import DatePeriod from "@/types/DatePeriod";
import PeriodSelector from '@/components/PeriodSelector.vue';
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import { DisplayableKeys } from "@/services/SorterService";
import {  MonetaryValueWithCommas, formatTitileFromCanonicalWithExceptions } from "@/services/helpers/Helper";
import { downloadManager, vcfsConsolidation, vcfsPeriodConsituentItemsTrialBalance, vcfsTrialBalance, vcfsTrialBalanceJournalReferenceItems } from "@/services/network";
import { IVcfsTrialBalance } from "src/Interfaces/VcfsTrialBalance/IVcfsTrialBalance";
import { IVcfsTrialBalanceConstituentItem } from "src/Interfaces/VcfsTrialBalance/IVcfsTrialBalanceConstituentItem";
import VcfsTrialBalancePopUp from "@/components/VcfsTrialBalancePopUp.vue";
import ExportCsv from "@/components/ExportCsv.vue";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { authService } from "@/auth/authSingleton";
import { FunctionAccessLevels, DenyFunctionLevelAccess } from "@/config/AuthConfig";
import { VcfsTrialBalanceStatementCategories } from "@/models/enums/VcfsTrialBalanceStatementCategories";
import { FileDownloadType } from "@/models/enums/FileDownloadTypes";

enum tabs {
    TRIAL_BALANCE_PERIOD = "TRIAL_BALANCE_PERIOD",
    TRIAL_BALANCE_ACCUMULATED = "TRIAL_BALANCE_ACCUMULATED",
    PROFIT_AND_LOSS = "PROFIT_AND_LOSS",
    BALANCE_SHEET = "BALANCE_SHEET"
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VcfsTrialBalance',
  setup(__props) {

const tabConfig = [
  { key: tabs.TRIAL_BALANCE_PERIOD, label: "Trial Balance - Period", position: "left" },
  { key: tabs.TRIAL_BALANCE_ACCUMULATED, label: "Trial Balance - Accumulated", position: "middle" },
  { key: tabs.PROFIT_AND_LOSS, label: "Profit & Loss", position: "middle" },
  { key: tabs.BALANCE_SHEET, label: "Balance Sheet", position: "right" }
];
const currentTab = ref<tabs>(tabs.TRIAL_BALANCE_PERIOD);
const period = ref(new DatePeriod(new Date().addMonths(-1)));
const getVcfsPeriodTrialBalanceError = ref(false)
const isLoading = ref(false);
const isLoadingTopLevel = ref(false);
const expanded = ref<boolean>(false);
const expandedUpToPeriod = ref<boolean>(false);
const expandedUpToPeriodTopLevel = ref<boolean>(false);
const expandedRowAccount = ref();
const expandedRowAccountUpToPeriod = ref();
const expandedRowPeriodUpToPeriod = ref();
const expandedRowAccountUpToPeriodTopLevel = ref();
const upToPeriodTrialBalanceRows = ref<IVcfsTrialBalance[]>([]);
const upToPeriodTrialBalanceTopLevelRows = ref<Partial<IVcfsTrialBalance>[]>([]);
const balanceSheetTopLevelRows = ref<Partial<IVcfsTrialBalance>[]>([]);
const periodTrialBalanceRows = ref<IVcfsTrialBalance[]>([]);
const profitAndLossRows = ref<IVcfsTrialBalance[]>([]);
const balanceSheetRows = ref<IVcfsTrialBalance[]>([]);
const periodTrialBalanceRowsExpandable = ref<IVcfsTrialBalanceConstituentItem[]>([]);
const upToPeriodTrialBalanceRowsExpandable = ref<IVcfsTrialBalanceConstituentItem[]>([]);
const upToPeriodTrialBalanceRowsExpandableTopLevel = ref<IVcfsTrialBalance[]>([]);
const balanceSheetRowsExpandableTopLevel = ref<IVcfsTrialBalance[]>([]);
const balanceSheetRowsExpandable = ref<IVcfsTrialBalanceConstituentItem[]>([]);
const expandedBalanceSheetTopLevel = ref(false);
const expandedRowAccountBalanceSheetTopLevel = ref();
const expandedBalanceSheet = ref(false);
const expandedRowAccountBalanceSheet = ref();
const expandedRowPeriodBalanceSheet = ref();
const emailAddress = authService.getEmailAddress();
//popUp 
const vcfsTrialBalancePopUpRows = ref<Record<string, any>[]>([])
const journalAccountPopUp = ref("")
const journalReferencePopUp = ref("")
const popUpOpen = ref(false);
//Table cols
const trialBalanceCols: Array<keyof IVcfsTrialBalance> = [ "account", "totalDebit", "totalCredit", "tbJournalReference" ];
const topLevelUpToPeriodCols: Array<keyof IVcfsTrialBalance> = [ "account", "totalDebit", "totalCredit", ];
const upToPeriodTrialBalanceCols: Array<keyof IVcfsTrialBalance> = [ "account", "totalDebit", "totalCredit", "tbJournalReference", "period" ];
const trialBalanceColsExpandable: DisplayableKeys<IVcfsTrialBalanceConstituentItem>[] = ['journalReference', "debitAmount", "creditAmount", "journalType", "ownerId", "journalingDate"];
const balanceSheetTopLevelCols: Array<keyof IVcfsTrialBalance> = ["account", "totalDebit", "totalCredit"];
const balanceSheetCols: Array<keyof IVcfsTrialBalance> = ["account", "totalDebit", "totalCredit", "tbJournalReference", "period"];
//Table labs
const topLevelUpToPeriodTrialBalanceLabels = [ "Account", "Total Debit", "Total Credit"]
const trialBalanceLabels = [ "Account", "Total Debit", "Total Credit", "TB Journal Reference"]
const trialBalanceLabelsExpandable = [ 'Journal Reference', "Debit Amount", "Credit Amount", "Journaling Type", "Owner ID", "Journaling Date" ];
const upToPeriodTrialBalanceLabels = [ "Account", "Total Debit", "Total Credit", "TB Journal Reference", "Period" ];
const balanceSheetLabelsTopLevel = ["Account", "Total Debit", "Total Credit"];
const balanceSheetLabels = ["Account", "Total Debit", "Total Credit", "TB Journal Reference", "Period"];

const summaryColsProfitAndLoss: DisplayableKeys<IVcfsTrialBalance>[] = ["totalDebit", "totalCredit"]
const summaryColsBalanceSheet: DisplayableKeys<IVcfsTrialBalance>[] = ["totalDebit", "totalCredit"]
watch(profitAndLossRows, (newVal) => {
  console.log("profitAndLossRows updated:", newVal);
  console.log("totalDebit:", totalDebitProfitAndLoss.value);
console.log("totalCredit:", totalCreditProfitAndLoss.value);
console.log("totalProfit:", totalProfit.value)
});
const totalDebitProfitAndLoss = computed(() =>
  Math.round(profitAndLossRows.value.reduce((sum, item) => sum + (Number(item.totalDebit) || 0), 0) * 100) / 100
);
const totalCreditProfitAndLoss = computed(() =>
  Math.round(profitAndLossRows.value.reduce((sum, item) => sum + (Number(item.totalCredit) || 0), 0) * 100) / 100
);
const totalProfit = computed(()=>
    Math.round((totalCreditProfitAndLoss.value - totalDebitProfitAndLoss.value) * 100) / 100
)
const totalDebitBalanceSheet = computed(() =>
  Math.round(balanceSheetTopLevelRows.value.reduce((sum, item) => sum + (Number(item.totalDebit) || 0), 0) * 100) / 100
);
const totalCreditBalanceSheet = computed(() =>
  Math.round(balanceSheetTopLevelRows.value.reduce((sum, item) => sum + (Number(item.totalCredit) || 0), 0) * 100) / 100
);
const totalBalance = computed(()=>
    Math.round((totalDebitBalanceSheet.value - totalCreditBalanceSheet.value ) * 100) / 100
)
const summaryValuesProfitAndLoss = computed(() => [totalDebitProfitAndLoss.value, totalCreditProfitAndLoss.value]);
const summaryValuesBalanceSheet = computed(() => [totalDebitBalanceSheet.value, totalCreditBalanceSheet.value]);
onMounted(async () => {
    document.title = 'Vcfs Trial Balance - UV';
    await getVcfsPeriodTrialBalance();
    await getVcfsUpToPeriodTrialBalance();
});
const disableExport = computed(() => {
    return getVcfsPeriodTrialBalanceError.value == true ||  periodTrialBalanceRows.value.length == 0
});
const disableConsolidation = computed(() => {
    return getVcfsPeriodTrialBalanceError.value == true ||  periodTrialBalanceRows.value.length > 0
});
watch(upToPeriodTrialBalanceRows, (newVal) => {
    if (!newVal || newVal.length === 0) {
        upToPeriodTrialBalanceTopLevelRows.value = [];
        return;
    }
    const grouped = Object.groupBy(newVal, item => item.account)
    const result = Object.entries(grouped).map(([account, items = []]) => {
        const totalDebit = items.reduce((sum, i) => sum + (i.totalDebit ?? 0), 0);
        const totalCredit = items.reduce((sum, i) => sum + (i.totalCredit ?? 0), 0)
        const creditDebitDifference = totalDebit - totalCredit;
        return {
            account,
            totalDebit: creditDebitDifference > 0 ? creditDebitDifference : 0,
            totalCredit: creditDebitDifference < 0 ? -creditDebitDifference : 0,
        };
    });
    upToPeriodTrialBalanceTopLevelRows.value = result;
});
watch(balanceSheetRows, (newVal) => {
  if (!newVal || newVal.length === 0) {
    balanceSheetTopLevelRows.value = [];
    return;
  }
  const grouped = Object.groupBy(newVal, item => item.account);
  const result = Object.entries(grouped).map(([account, items = []]) => {
    const totalDebit = items.reduce((sum, i) => sum + (i.totalDebit ?? 0), 0);
    const totalCredit = items.reduce((sum, i) => sum + (i.totalCredit ?? 0), 0);
    const diff = totalDebit - totalCredit;
    return {
      account,
      totalDebit: diff > 0 ? diff : 0,
      totalCredit: diff < 0 ? -diff : 0
    };
  });
  balanceSheetTopLevelRows.value = result;
});
watch([period, currentTab], async ([newPeriod, newCurrentTab]) => {
    if (!newPeriod) return;
    if (newCurrentTab == tabs.TRIAL_BALANCE_PERIOD) {
        await getVcfsPeriodTrialBalance();
    }
    if(newCurrentTab == tabs.TRIAL_BALANCE_ACCUMULATED){
        await getVcfsUpToPeriodTrialBalance();
    }
    if(newCurrentTab == tabs.PROFIT_AND_LOSS){
        await getVcfsProfitAndLoss()
    }if(newCurrentTab == tabs.BALANCE_SHEET){
        await getVcfsBalanceSheet()
    }
});
async function getVcfsPeriodTrialBalance() {
    if(isLoadingTopLevel.value) return
    resetPeriodTrialBalanceExpandableRow()
    try {
        getVcfsPeriodTrialBalanceError.value = false
        isLoadingTopLevel.value = true
        const data = (await vcfsTrialBalance.get({period: period.value.toString()})).data        
        periodTrialBalanceRows.value = data;
    } catch (error) {
        useNotifierWithErrFormatter().error({errorType:"Getting VCFS Period Trial Balance", error})
        getVcfsPeriodTrialBalanceError.value = true
    } finally {
        isLoadingTopLevel.value = false;
    }
}
async function getVcfsProfitAndLoss() {
    if(isLoadingTopLevel.value) return
    resetPeriodTrialBalanceExpandableRow()
    try {
        isLoadingTopLevel.value = true
        const data = (await vcfsTrialBalance.get({period: period.value.toString(), statementCategory: VcfsTrialBalanceStatementCategories[VcfsTrialBalanceStatementCategories.PL] as keyof typeof VcfsTrialBalanceStatementCategories})).data        
        profitAndLossRows.value = data;
    } catch (error) {
        useNotifierWithErrFormatter().error({errorType:"Getting VCFS Profit and Loss Balance", error})
    } finally {
        isLoadingTopLevel.value = false;
    }
}
async function getVcfsBalanceSheet() {
    if(isLoadingTopLevel.value) return
    resetBalanceSheetExpandableRows()
    try {
        isLoadingTopLevel.value = true
        const data = (await vcfsTrialBalance.get({period: period.value.toString(), statementCategory: VcfsTrialBalanceStatementCategories[VcfsTrialBalanceStatementCategories.BS] as keyof typeof VcfsTrialBalanceStatementCategories})).data        
        balanceSheetRows.value = data;
    } catch (error) {
        useNotifierWithErrFormatter().error({errorType:"Getting VCFS Balance Sheet", error})
    } finally {
        isLoadingTopLevel.value = false;
    }
}
function resetBalanceSheetExpandableRows() {
  expandedBalanceSheetTopLevel.value = false;
  expandedRowAccountBalanceSheetTopLevel.value = null;
  balanceSheetRowsExpandableTopLevel.value = [];

  expandedBalanceSheet.value = false;
  expandedRowAccountBalanceSheet.value = null;
  expandedRowPeriodBalanceSheet.value = null;
  balanceSheetRowsExpandable.value = [];
}

async function expansionGetterBalanceSheetTopLevel(row: Partial<IVcfsTrialBalance>) {
  if (expandedRowAccountBalanceSheetTopLevel.value === row.account) {
    resetBalanceSheetExpandableRows();
  } else {
    isLoading.value = true;
    expandedBalanceSheetTopLevel.value = true;
    expandedRowAccountBalanceSheetTopLevel.value = row.account;
    balanceSheetRowsExpandableTopLevel.value = balanceSheetRows.value.filter(item => item.account === row.account);
    isLoading.value = false;
  }
}

async function expansionGetterBalanceSheet(row: IVcfsTrialBalance) {
  if (expandedRowAccountBalanceSheet.value === row.account && expandedRowPeriodBalanceSheet.value === row.period) {
    expandedBalanceSheet.value = false;
    expandedRowAccountBalanceSheet.value = null;
    expandedRowPeriodBalanceSheet.value = null;
    balanceSheetRowsExpandable.value = [];
  } else {
    expandedBalanceSheet.value = true;
    expandedRowAccountBalanceSheet.value = row.account;
    expandedRowPeriodBalanceSheet.value = row.period;
    isLoading.value = true;
    const data = (await vcfsPeriodConsituentItemsTrialBalance.get(
      { account: row.account },
      { period: row.period.toString() }
    )).data;
    balanceSheetRowsExpandable.value = data;
    isLoading.value = false;
  }
}
async function getVcfsUpToPeriodTrialBalance() {
    if(isLoadingTopLevel.value) return
    resetUpToPeriodTrialBalanceExpandableRow()
    try {
        isLoadingTopLevel.value = true
        const data = (await vcfsTrialBalance.get({period: period.value.toString(), upToPeriod: true })).data        
        upToPeriodTrialBalanceRows.value = data;
    } catch (error) {
        useNotifierWithErrFormatter().error({errorType:"Getting VCFS Up to Period Trial Balance", error})
    } finally {
        isLoadingTopLevel.value = false;
    }
}
function resetPeriodTrialBalanceExpandableRow(){
    expanded.value = false;
    expandedRowAccount.value = null;
    periodTrialBalanceRowsExpandable.value = [];
}
function resetUpToPeriodTrialBalanceExpandableRow(){
    expandedUpToPeriod.value = false;
    expandedRowAccountUpToPeriod.value = null;
    expandedRowPeriodUpToPeriod.value = null;
    upToPeriodTrialBalanceRowsExpandable.value = [];
}
function resetUpToPeriodTrialBalanceExpandableRowTopLevel(){
    expandedUpToPeriodTopLevel.value = false;
    expandedRowAccountUpToPeriodTopLevel.value = null;
    upToPeriodTrialBalanceRowsExpandableTopLevel.value = [];
}
async function expansionGetterPeriod(row: IVcfsTrialBalance){
    if (expandedRowAccount.value === row.account) {
        resetPeriodTrialBalanceExpandableRow()
    } else {
        expanded.value = true;
        expandedRowAccount.value = row.account;           
        isLoading.value = true;    
        const data = (await vcfsPeriodConsituentItemsTrialBalance.get({account:row.account}, {period: period.value.toString()})).data
        periodTrialBalanceRowsExpandable.value = data;
        isLoading.value = false
    }
}
async function expansionGetterUpToPeriod(row: IVcfsTrialBalance){
    if (expandedRowAccountUpToPeriod.value === row.account && expandedRowPeriodUpToPeriod.value == row.period) {
        resetUpToPeriodTrialBalanceExpandableRow()
    } else {
        expandedUpToPeriod.value = true;
        expandedRowAccountUpToPeriod.value = row.account;  
        expandedRowPeriodUpToPeriod.value = row.period;    
        isLoading.value = true;
        const data = (await vcfsPeriodConsituentItemsTrialBalance.get({account:row.account}, {period: row.period.toString()})).data 
        upToPeriodTrialBalanceRowsExpandable.value = data;
        isLoading.value = false
    }
}
async function expansionGetterUpToPeriodTopLevel(row: Partial<IVcfsTrialBalance>) {
    if (expandedRowAccountUpToPeriodTopLevel.value === row.account) {
        resetUpToPeriodTrialBalanceExpandableRowTopLevel()
    } else {
        isLoading.value = true;
        expandedUpToPeriodTopLevel.value = true;
        expandedRowAccountUpToPeriodTopLevel.value = row.account;
        upToPeriodTrialBalanceRowsExpandableTopLevel.value = upToPeriodTrialBalanceRows.value.filter(
            item => item.account === row.account
        );
        isLoading.value = false;
    }
}
async function ViewJNLReference(row: IVcfsTrialBalanceConstituentItem, account: string, period: string){
    const closeSpinner = useSpinnerPopup().show();
    try {
        const journalReference = row.journalReference

        const response = await vcfsTrialBalanceJournalReferenceItems.get({account: account, journalReference: journalReference} , {period: period.toString()}) 
        const data = response.data

        journalAccountPopUp.value = account
        journalReferencePopUp.value = journalReference
        
        if(response.status == 204){
            const message204 = account + " does not support journal reference look up"
            useNotifierWithErrFormatter().notify({msg: message204});
            return
        }
        if (Array.isArray(data) && typeof data[0] === 'object') {
            vcfsTrialBalancePopUpRows.value = data;
            popUpOpen.value = true
            return
        }
        if (!Array.isArray(data) || data.length === 0) {
            const emptyDataMessage = `No data is available for journal reference "${journalReference}".`;
            useNotifierWithErrFormatter().notify({ msg: emptyDataMessage });
            return;
        }
    } catch (error) {
        useNotifierWithErrFormatter().error({errorType:"Getting VCFS Period Trial Balance", error})
    } finally {
        closeSpinner()
    }
}
async function Consolidation(){
    if(isLoading.value) return
    const closeSpinner = useSpinnerPopup().show();
    try{
        isLoading.value = true
        const response = await vcfsConsolidation.post({period: period.value.toString()})
        if(response.status == 204){
            useNotifierWithErrFormatter().notify({msg: "No eligible data to consolidate"})
        }
        else{
            useNotifierWithErrFormatter().success({msg: "VCFS Trial Consolidated"})
            isLoading.value = false
            await getVcfsPeriodTrialBalance()
        }
    }catch(err){
        useNotifierWithErrFormatter().error({errorType: "VCFS Trial Consolidation", error: err})
    }finally{
        isLoading.value = false
        closeSpinner()
    }
}
async function ExportData() {
    const closeSpinner = useSpinnerPopup().show();
    try {
        await downloadManager.post({
            userName: emailAddress,
            type: FileDownloadType.VCFS_ACCOUNTING_REPORT,
            requestData:
            {
                PeriodMonth: new DatePeriod(period.value)
            }
        })
        useNotifierWithErrFormatter().success({
            msg: "VCFS accounting report was queued for download"
        });
    } catch(error) {
        useNotifierWithErrFormatter().error({
            errorType: "VCFS accounting report download queue error",
            error,
        });
    } finally {
        closeSpinner();
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabConfig, (tab) => {
          return _createElementVNode("div", {
            key: tab.key,
            class: "tabs"
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(`button-${tab.position} ${currentTab.value === tab.key ? 'selected' : 'unselected'}`),
              disabled: currentTab.value === tab.key,
              title: currentTab.value === tab.key ? `Currently viewing ${tab.label}` : `Click to view ${tab.label}`,
              onClick: ($event: any) => (currentTab.value = tab.key)
            }, _toDisplayString(tab.label), 11, _hoisted_3)
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (currentTab.value == tabs.TRIAL_BALANCE_PERIOD)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _withModifiers(Consolidation, ["prevent"]),
                  class: "incident-nav-button",
                  disabled: disableConsolidation.value || _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).VcfsConsolidation, true),
                  title: disableConsolidation.value ? 'This period has already been consolidated' : (_unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).VcfsConsolidation, true) ? 'You are not authorised to perform this action' : '')
                }, " Consolidate Trial Balance ", 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true),
          _createVNode(PeriodSelector, {
            modelValue: period.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((period).value = $event)),
            showTitle: ""
          }, null, 8, ["modelValue"]),
          (currentTab.value == tabs.TRIAL_BALANCE_PERIOD)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "incident-nav-button",
                  disabled: disableExport.value,
                  title: disableExport.value? 'No data to export' : '',
                  onClick: ExportData
                }, "Export Data", 8, _hoisted_10)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (isLoadingTopLevel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
        : _createCommentVNode("", true),
      (currentTab.value == tabs.TRIAL_BALANCE_PERIOD && !isLoadingTopLevel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(ExportCsv, {
                dataToDownload: periodTrialBalanceRows.value,
                fileName: 'VCFS_Trial_Balance_For_Period_'+ period.value,
                columnsToRemove: ['period']
              }, null, 8, ["dataToDownload", "fileName"])
            ]),
            _createVNode(TablePersistentChecking, {
              Rows: periodTrialBalanceRows.value,
              Cols: trialBalanceCols,
              Labels: trialBalanceLabels,
              RowClickedCallBack: expansionGetterPeriod
            }, {
              account: _withCtx(({value}) => [
                _createElementVNode("div", null, _toDisplayString(_unref(formatTitileFromCanonicalWithExceptions)(value.account)), 1)
              ]),
              totalDebit: _withCtx(({ value }) => [
                _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.totalDebit)), 1)
              ]),
              totalCredit: _withCtx(({ value }) => [
                _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.totalCredit)), 1)
              ]),
              "post-row": _withCtx(({ value }) => [
                (expanded.value && expandedRowAccount.value === value.account)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("td", {
                        colspan: trialBalanceCols.length + 20,
                        class: "inner-table-cont"
                      }, [
                        (isLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(ExportCsv, {
                              dataToDownload: periodTrialBalanceRowsExpandable.value,
                              fileName: 'VCFS_Trial_Balance_For_Period_'+ period.value + '_items'
                            }, null, 8, ["dataToDownload", "fileName"])
                          ]),
                          _createVNode(TablePersistentChecking, {
                            class: "inner-table",
                            Rows: periodTrialBalanceRowsExpandable.value,
                            Cols: trialBalanceColsExpandable,
                            Labels: trialBalanceLabelsExpandable,
                            RowClickedCallBack: (row) => ViewJNLReference(row, expandedRowAccount.value, period.value.toString())
                          }, {
                            journalType: _withCtx(({value}) => [
                              _createElementVNode("div", null, _toDisplayString(_unref(formatTitileFromCanonicalWithExceptions)(value.journalType)), 1)
                            ]),
                            debitAmount: _withCtx(({ value }) => [
                              _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.debitAmount)), 1)
                            ]),
                            creditAmount: _withCtx(({ value }) => [
                              _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.creditAmount)), 1)
                            ]),
                            _: 2
                          }, 1032, ["Rows", "RowClickedCallBack"])
                        ])
                      ], 8, _hoisted_18)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["Rows"])
          ]))
        : _createCommentVNode("", true),
      (currentTab.value == tabs.TRIAL_BALANCE_ACCUMULATED && !isLoadingTopLevel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(ExportCsv, {
                dataToDownload: upToPeriodTrialBalanceTopLevelRows.value,
                fileName: 'VCFS_Trial_Balance_Up_To_Period('+ period.value +')'
              }, null, 8, ["dataToDownload", "fileName"])
            ]),
            _createVNode(TablePersistentChecking, {
              Rows: upToPeriodTrialBalanceTopLevelRows.value,
              Cols: topLevelUpToPeriodCols,
              Labels: topLevelUpToPeriodTrialBalanceLabels,
              RowClickedCallBack: expansionGetterUpToPeriodTopLevel
            }, {
              account: _withCtx(({value}) => [
                _createElementVNode("div", null, _toDisplayString(_unref(formatTitileFromCanonicalWithExceptions)(value.account?? "")), 1)
              ]),
              totalDebit: _withCtx(({ value }) => [
                _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.totalDebit)), 1)
              ]),
              totalCredit: _withCtx(({ value }) => [
                _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.totalCredit)), 1)
              ]),
              "post-row": _withCtx(({ value }) => [
                (expandedUpToPeriodTopLevel.value && expandedRowAccountUpToPeriodTopLevel.value === value.account)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("td", {
                        colspan: topLevelUpToPeriodCols.length + 20,
                        class: "inner-table-cont"
                      }, [
                        (isLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                          : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createVNode(ExportCsv, {
                                    dataToDownload: upToPeriodTrialBalanceRowsExpandableTopLevel.value,
                                    fileName: expandedRowAccountUpToPeriodTopLevel.value + '_' + 'VCFS_Trial_Balance_Up_To_Period'
                                  }, null, 8, ["dataToDownload", "fileName"])
                                ]),
                                _createVNode(TablePersistentChecking, {
                                  class: "inner-table",
                                  Rows: upToPeriodTrialBalanceRowsExpandableTopLevel.value,
                                  Cols: upToPeriodTrialBalanceCols,
                                  Labels: upToPeriodTrialBalanceLabels,
                                  RowClickedCallBack: expansionGetterUpToPeriod
                                }, {
                                  account: _withCtx(({value}) => [
                                    _createElementVNode("div", null, _toDisplayString(_unref(formatTitileFromCanonicalWithExceptions)(value.account)), 1)
                                  ]),
                                  totalDebit: _withCtx(({ value }) => [
                                    _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.totalDebit)), 1)
                                  ]),
                                  totalCredit: _withCtx(({ value }) => [
                                    _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.totalCredit)), 1)
                                  ]),
                                  "post-row": _withCtx(({ value }) => [
                                    (expandedUpToPeriod.value && expandedRowAccountUpToPeriod.value === value.account && expandedRowPeriodUpToPeriod.value === value.period)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                                      : _createCommentVNode("", true),
                                    (expandedUpToPeriod.value && expandedRowAccountUpToPeriod.value === value.account && expandedRowPeriodUpToPeriod.value === value.period)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                                          _hoisted_37,
                                          _createElementVNode("td", {
                                            colspan: upToPeriodTrialBalanceCols.length + 20
                                          }, [
                                            _createElementVNode("div", _hoisted_39, [
                                              (isLoading.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_43, [
                                                  _createVNode(ExportCsv, {
                                                    dataToDownload: upToPeriodTrialBalanceRowsExpandable.value,
                                                    fileName: expandedRowAccountUpToPeriod.value + '_' + expandedRowPeriodUpToPeriod.value + '_' + 'VCFS_Trial_Balance_Up_To_Period'
                                                  }, null, 8, ["dataToDownload", "fileName"])
                                                ]),
                                                _createVNode(TablePersistentChecking, {
                                                  class: "inner-table",
                                                  Rows: upToPeriodTrialBalanceRowsExpandable.value,
                                                  Cols: trialBalanceColsExpandable,
                                                  Labels: trialBalanceLabelsExpandable,
                                                  RowClickedCallBack: (row) => ViewJNLReference(row, expandedRowAccountUpToPeriod.value, expandedRowPeriodUpToPeriod.value)
                                                }, {
                                                  journalType: _withCtx(({value}) => [
                                                    _createElementVNode("div", null, _toDisplayString(_unref(formatTitileFromCanonicalWithExceptions)(value.journalType)), 1)
                                                  ]),
                                                  debitAmount: _withCtx(({ value }) => [
                                                    _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.debitAmount)), 1)
                                                  ]),
                                                  creditAmount: _withCtx(({ value }) => [
                                                    _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.creditAmount)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["Rows", "RowClickedCallBack"])
                                              ])
                                            ])
                                          ], 8, _hoisted_38)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["Rows"])
                              ])
                            ]))
                      ], 8, _hoisted_28)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["Rows"])
          ]))
        : _createCommentVNode("", true),
      (currentTab.value == tabs.PROFIT_AND_LOSS && !isLoadingTopLevel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createVNode(ExportCsv, {
                dataToDownload: profitAndLossRows.value,
                fileName: 'VCFS_Trial_Balance_Profit_And_Loss'+ period.value,
                columnsToRemove: ['period']
              }, null, 8, ["dataToDownload", "fileName"])
            ]),
            _createVNode(TablePersistentChecking, {
              Rows: profitAndLossRows.value,
              Cols: trialBalanceCols,
              Labels: trialBalanceLabels,
              RowClickedCallBack: expansionGetterPeriod,
              SummaryCols: summaryColsProfitAndLoss,
              SummaryValues: summaryValuesProfitAndLoss.value,
              SummaryLabel: "Subtotal"
            }, {
              account: _withCtx(({value}) => [
                _createElementVNode("div", null, _toDisplayString(_unref(formatTitileFromCanonicalWithExceptions)(value.account)), 1)
              ]),
              totalDebit: _withCtx(({ value }) => [
                _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.totalDebit)), 1)
              ]),
              totalCredit: _withCtx(({ value }) => [
                _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.totalCredit)), 1)
              ]),
              "post-row": _withCtx(({ value }) => [
                (expanded.value && expandedRowAccount.value === value.account)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("td", {
                        colspan: trialBalanceCols.length + 20,
                        class: "inner-table-cont"
                      }, [
                        (isLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _createVNode(ExportCsv, {
                              dataToDownload: periodTrialBalanceRowsExpandable.value,
                              fileName: 'VCFS_Trial_Balance_Profit_And_Loss'+ period.value + '_items'
                            }, null, 8, ["dataToDownload", "fileName"])
                          ]),
                          _createVNode(TablePersistentChecking, {
                            class: "inner-table",
                            Rows: periodTrialBalanceRowsExpandable.value,
                            Cols: trialBalanceColsExpandable,
                            Labels: trialBalanceLabelsExpandable,
                            RowClickedCallBack: (row) => ViewJNLReference(row, expandedRowAccount.value, period.value.toString())
                          }, {
                            journalType: _withCtx(({value}) => [
                              _createElementVNode("div", null, _toDisplayString(_unref(formatTitileFromCanonicalWithExceptions)(value.journalType)), 1)
                            ]),
                            debitAmount: _withCtx(({ value }) => [
                              _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.debitAmount)), 1)
                            ]),
                            creditAmount: _withCtx(({ value }) => [
                              _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.creditAmount)), 1)
                            ]),
                            _: 2
                          }, 1032, ["Rows", "RowClickedCallBack"])
                        ])
                      ], 8, _hoisted_48)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["Rows", "SummaryValues"]),
            (totalProfit.value>=0)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_54, [
                  _createTextVNode("Total Profit: "),
                  _createElementVNode("span", _hoisted_55, _toDisplayString(_unref(MonetaryValueWithCommas)(totalProfit.value)), 1)
                ]))
              : (_openBlock(), _createElementBlock("h4", _hoisted_56, [
                  _createTextVNode("Total Loss: "),
                  _createElementVNode("span", _hoisted_57, _toDisplayString(_unref(MonetaryValueWithCommas)(totalProfit.value)), 1)
                ]))
          ]))
        : _createCommentVNode("", true),
      (currentTab.value == tabs.BALANCE_SHEET && !isLoadingTopLevel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createVNode(ExportCsv, {
                dataToDownload: balanceSheetTopLevelRows.value,
                fileName: 'VCFS_Balance_Sheet_Up_To_Period_' + period.value
              }, null, 8, ["dataToDownload", "fileName"])
            ]),
            _createVNode(TablePersistentChecking, {
              Rows: balanceSheetTopLevelRows.value,
              Cols: balanceSheetTopLevelCols,
              Labels: balanceSheetLabelsTopLevel,
              RowClickedCallBack: expansionGetterBalanceSheetTopLevel,
              SummaryCols: summaryColsBalanceSheet,
              SummaryValues: summaryValuesBalanceSheet.value,
              SummaryLabel: "Subtotal"
            }, {
              account: _withCtx(({value}) => [
                _createElementVNode("div", null, _toDisplayString(_unref(formatTitileFromCanonicalWithExceptions)(value.account?? "")), 1)
              ]),
              totalDebit: _withCtx(({ value }) => [
                _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.totalDebit)), 1)
              ]),
              totalCredit: _withCtx(({ value }) => [
                _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.totalCredit)), 1)
              ]),
              "post-row": _withCtx(({ value }) => [
                (expandedBalanceSheetTopLevel.value && expandedRowAccountBalanceSheetTopLevel.value === value.account)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_60, [
                      _hoisted_61,
                      _createElementVNode("td", {
                        colspan: balanceSheetTopLevelCols.length + 20,
                        class: "inner-table-cont"
                      }, [
                        (isLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_65))
                          : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                  _createVNode(ExportCsv, {
                                    dataToDownload: balanceSheetRowsExpandableTopLevel.value,
                                    fileName: expandedRowAccountBalanceSheetTopLevel.value + '_VCFS_Balance_Sheet_Detail'
                                  }, null, 8, ["dataToDownload", "fileName"])
                                ]),
                                _createVNode(TablePersistentChecking, {
                                  class: "inner-table",
                                  Rows: balanceSheetRowsExpandableTopLevel.value,
                                  Cols: balanceSheetCols,
                                  Labels: balanceSheetLabels,
                                  RowClickedCallBack: expansionGetterBalanceSheet
                                }, {
                                  account: _withCtx(({value}) => [
                                    _createElementVNode("div", null, _toDisplayString(_unref(formatTitileFromCanonicalWithExceptions)(value.account)), 1)
                                  ]),
                                  totalDebit: _withCtx(({ value }) => [
                                    _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.totalDebit)), 1)
                                  ]),
                                  totalCredit: _withCtx(({ value }) => [
                                    _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.totalCredit)), 1)
                                  ]),
                                  "post-row": _withCtx(({ value }) => [
                                    (expandedBalanceSheet.value && expandedRowAccountBalanceSheet.value === value.account && expandedRowPeriodBalanceSheet.value === value.period)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_69, [
                                          _hoisted_70,
                                          _createElementVNode("td", {
                                            colspan: balanceSheetCols.length + 20
                                          }, [
                                            _createElementVNode("div", _hoisted_72, [
                                              (isLoading.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_75))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_76, [
                                                  _createVNode(ExportCsv, {
                                                    dataToDownload: balanceSheetRowsExpandable.value,
                                                    fileName: expandedRowAccountBalanceSheet.value + '_' + expandedRowPeriodBalanceSheet.value + '_VCFS_Balance_Sheet_Items'
                                                  }, null, 8, ["dataToDownload", "fileName"])
                                                ]),
                                                _createVNode(TablePersistentChecking, {
                                                  class: "inner-table",
                                                  Rows: balanceSheetRowsExpandable.value,
                                                  Cols: trialBalanceColsExpandable,
                                                  Labels: trialBalanceLabelsExpandable,
                                                  RowClickedCallBack: (row) => ViewJNLReference(row, expandedRowAccountBalanceSheet.value, expandedRowPeriodBalanceSheet.value)
                                                }, {
                                                  journalType: _withCtx(({value}) => [
                                                    _createElementVNode("div", null, _toDisplayString(_unref(formatTitileFromCanonicalWithExceptions)(value.journalType)), 1)
                                                  ]),
                                                  debitAmount: _withCtx(({ value }) => [
                                                    _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.debitAmount)), 1)
                                                  ]),
                                                  creditAmount: _withCtx(({ value }) => [
                                                    _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.creditAmount)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["Rows", "RowClickedCallBack"])
                                              ])
                                            ])
                                          ], 8, _hoisted_71)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["Rows"])
                              ])
                            ]))
                      ], 8, _hoisted_62)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["Rows", "SummaryValues"]),
            (totalBalance.value>=0)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_77, [
                  _createTextVNode("Total Balance: "),
                  _createElementVNode("span", _hoisted_78, _toDisplayString(_unref(MonetaryValueWithCommas)(totalBalance.value)), 1)
                ]))
              : (_openBlock(), _createElementBlock("h4", _hoisted_79, [
                  _createTextVNode("Total Balance: "),
                  _createElementVNode("span", _hoisted_80, _toDisplayString(_unref(MonetaryValueWithCommas)(totalBalance.value)), 1)
                ]))
          ]))
        : _createCommentVNode("", true),
      _createVNode(VcfsTrialBalancePopUp, {
        modelValue: popUpOpen.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((popUpOpen).value = $event)),
        tableRows: vcfsTrialBalancePopUpRows.value,
        journalAccount: journalAccountPopUp.value,
        journalReference: journalReferencePopUp.value
      }, null, 8, ["modelValue", "tableRows", "journalAccount", "journalReference"])
    ])
  ], 64))
}
}

})